import hostname from "./config.host";
import { fetchWrapper } from "./fetch-wrapper";
const apiUrl: string = `${hostname}/aladdin_api/v1`;

function getBrandConfigurationReport(oauthTokenHeader: string) {
  return fetchWrapper.get(
    `${apiUrl}/partners/affiliate_accounts/brands_integration`,
    oauthTokenHeader,
  );
}

function getBrandConfigPIECharts(
  oauthTokenHeader: string,
  website_shared_uid: string,
) {
  return fetchWrapper.get(
    `${apiUrl}/biz_layer_query/run/5708300221939712/?website_shared_uid=${website_shared_uid}`,
    oauthTokenHeader,
  );
}

function getBrandBackendRequirements(
  oauthTokenHeader: string,
  backend_shared_uid: string,
) {
  return fetchWrapper.get(
    `${apiUrl}/data_collection/fetcher/backend_requirements/${backend_shared_uid}/`,
    oauthTokenHeader,
  );
}

function getBrandProperties(
  oauthTokenHeader: string,
  brand_shared_uid: string,
) {
  return fetchWrapper.get(
    `${apiUrl}/partners/affiliate_accounts/brand_properties/${brand_shared_uid}/`,
    oauthTokenHeader,
  );
}

function editBrandProperties(
  oauthTokenHeader: string,
  data: any,
  brand_shared_uid: any,
) {
  return fetchWrapper.put(
    `${apiUrl}/partners/affiliate_accounts/brand_properties/${brand_shared_uid}/`,
    data,
    oauthTokenHeader,
  );
}

function postBrandConfigurationReport(oauthTokenHeader: string, data: any) {
  return fetchWrapper.post(
    `${apiUrl}/partners/affiliate_accounts/brands_integration`,
    data,
    oauthTokenHeader,
  );
}

//EP's Of Brand Configuration Overview Screen
function getBrandOverviewInfo(oauthTokenHeader: string, brand_id: string) {
  return fetchWrapper.get(
    `${apiUrl}/partners/affiliate_accounts/brands_integration/overview/brand_info/?brand_id=${brand_id}`,
    oauthTokenHeader,
  );
}

function getBrandOverviewLastRuns(oauthTokenHeader: string, brand_id: string) {
  return fetchWrapper.get(
    `${apiUrl}/data_collection/dc_process_log/last_runs/?brand_id=${brand_id}&limit=10`,
    oauthTokenHeader,
  );
}

function getBrandOverviewLastRecords(
  oauthTokenHeader: string,
  brand_id: string,
  report: string,
) {
  return fetchWrapper.get(
    `${apiUrl}/partners/affiliate_accounts/brands_integration/overview/last-records/?brand_id=${brand_id}&report=${report}`,
    oauthTokenHeader,
  );
}

function getBrandOverviewAdvisorSettings(
  oauthTokenHeader: string,
  brand_id: string,
  report: string,
) {
  return fetchWrapper.get(
    `${apiUrl}/partners/affiliate_accounts/brands_integration/overview/advisor_settings/?brand_id=${brand_id}&report=${report}`,
    oauthTokenHeader,
  );
}

function getBrandOverviewUnifierSettings(
  oauthTokenHeader: string,
  brand_id: string,
  report: string,
) {
  return fetchWrapper.get(
    `${apiUrl}/partners/affiliate_accounts/brands_integration/overview/unifier_settings/?brand_id=${brand_id}&report=${report}`,
    oauthTokenHeader,
  );
}

function getBrandOverviewFetcherSettings(
  oauthTokenHeader: string,
  reqBody: any,
) {
  return fetchWrapper.post(
    `${apiUrl}/partners/affiliate_accounts/brands_integration/overview/fetcher_settings/`,
    reqBody,
    oauthTokenHeader,
  );
}

function brandsRunProcess(oauthTokenHeader: string, data: any) {
  return fetchWrapper.post(
    `${apiUrl}/operations/argo/template/`,
    data,
    oauthTokenHeader,
  );
}
function getAllConfigForFetcher(
  oauthTokenHeader: string,
  biz_layer_query_id: any,
  website_shared_uid: any,
) {
  return fetchWrapper.get(
    `${apiUrl}/biz_layer_query/run/${biz_layer_query_id}/?website_shared_uid=${website_shared_uid}`,
    oauthTokenHeader,
  );
}

function getOverviewPerformance(
  oauthTokenHeader: string,
  biz_layer_query_id: any,
  website_shared_uid: any,
  type: any,
  brand_id: any,
  start_date: any,
  end_date: any,
  limit: any,
) {
  return fetchWrapper.get(
    `${apiUrl}/biz_layer_query/run/${biz_layer_query_id}/?website_shared_uid=${website_shared_uid}&type=${type}&brand_id=${brand_id}&start_date=${start_date}&end_date=${end_date}&limit=${limit}`,
    oauthTokenHeader,
  );
}

function getObjectsData(
  oauthTokenHeader: string,
  biz_layer_query_id: any,
  website_shared_uid: any,
  type: any,
  brand_id: any,
) {
  return fetchWrapper.get(
    `${apiUrl}/biz_layer_query/run/${biz_layer_query_id}/?website_shared_uid=${website_shared_uid}&type=${type}&brand_id=${brand_id}`,
    oauthTokenHeader,
  );
}

export const brandConfigReportService = {
  getBrandConfigurationReport,
  getBrandConfigPIECharts,
  getBrandBackendRequirements,
  getBrandProperties,
  editBrandProperties,
  postBrandConfigurationReport,
  getBrandOverviewInfo,
  getBrandOverviewLastRuns,
  getBrandOverviewLastRecords,
  getBrandOverviewAdvisorSettings,
  getBrandOverviewUnifierSettings,
  getBrandOverviewFetcherSettings,
  brandsRunProcess,
  getAllConfigForFetcher,
  getOverviewPerformance,
  getObjectsData,
};
